import React from "react";
import OrderTable from "../Table";

const OrderProcessing = () => {
  return <OrderTable type="Order Processing" />;
};

export default OrderProcessing;
